import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(CSSRulePlugin);


export default function gsapAnimations() {

  // shown on ecommerce masthead
  function waves() {
    if (!document.querySelector('.wavey')) return;
    const tl = new gsap.timeline({yoyo: true, repeat: -1, ease: "back.inOut(1)"});
    tl.to(".wavey", {y: ()=> gsap.utils.random(-20, 20)+'%', delay: (i) => gsap.utils.random(0, 3), duration: ()=> gsap.utils.random(7,10), ease:"back.inOut(1)"});
  }
  waves();

  function textAndStatCard() {
    if (!document.querySelector('.text-and-stats-card')) return;
    gsap.fromTo('.text-and-stats-card', {
      x: 100,
      opacity: 0
    }, {
      x:0,
      opacity: 1,
      delay:(i)=>{return i/5},
      ease:"none.none",
      scrollTrigger: {
        trigger:  ".text-and-stats",
        start: "top center", // when the top of the trigger hits the top of the viewport
        end: "bottom bottom", // when the bottom of the endTrigger hits the center of the scroller"
        scrub: 4,
      },
    });
  }
  textAndStatCard();

  function parallaxCards() {
    if (!document.querySelector('.parallax-cards-item')) return;
    ScrollTrigger.saveStyles(".parallax-cards-item"); // if you put this INSIDE one of the functions, it'll only revert the recorded elements when that media query no longer matches. You can use ScrollTrigger.saveStyles() in multiple places.
    ScrollTrigger.matchMedia({
      // desktop
      "(min-width: 1024px)": function() {
        let i = -1;
        gsap.to('.parallax-cards-item', {
          scrollTrigger: {
            trigger:  ".parallax-cards",
            // markers: true,
            start: "top top", // when the top of the trigger hits the top of the viewport
            end: "center top", // when the bottom of the endTrigger hits the center of the scroller"
            scrub: 1,
            // pin:true,
          },
          ease:"power0.out",
          y: () => { i++; if (i%2===0) {return '-2rem'} else {return '2rem'}}
        });
      },
    });
  }
  parallaxCards();


  function parallaxPhoneScroll() {
    if (!document.querySelector('.parallax-phone-scroll')) return;
    ScrollTrigger.saveStyles(".parallax-phone-scroll, parallax-phone-scroll .absolute");
    ScrollTrigger.matchMedia({
      "(min-width: 0px)": function() {
        const phoneImages = [...document.querySelectorAll('.parallax-phone-image')];

        const tl = new gsap.timeline({
          ease: "none",
          scrollTrigger: {
            trigger:  ".parallax-phone-scroll",
            start: "top top",
            end: "+=2500",
            scrub: 1,
            pin: true
          },
        });

        phoneImages.forEach((el, i) => {
          const icons = [...document.querySelectorAll('.parallax-phone-icon-item')];
          tl.from(icons[i], {
            x: i % 2 === 0 ? '-100%' : '100%',
            rotation: i => i % 2 === 0 ? '-10deg' : '10deg',
            opacity: 0,
            ease: "power0.out",
          }, i);

          tl.to(el, {
            opacity: 1,
            ease: "none",
          }, i);
        })
      }
    })
  }
  parallaxPhoneScroll();


  function stackedCards() {
    if (!document.querySelector('.stacked-cards')) return;
    ScrollTrigger.saveStyles(".stacked-card");
    const cards = gsap.utils.toArray(".stacked-card");

    ScrollTrigger.matchMedia({
      // "(min-width: 769px)": () => {
      //   const spacer = 20;

      //   cards.forEach((card, index) => {
      //     const tween = gsap.to(card, {
      //       scrollTrigger: {
      //         trigger: card,
      //         start: `top top+=365`,
      //         scrub: true,
      //         invalidateOnRefresh: true
      //       },
      //       ease: "none.none",
      //       scale: () => 1 - (cards.length - index) * 0.025,
      //     });

      //     ScrollTrigger.create({
      //       trigger: card,
      //       start: `top-=${index * spacer} top+=150`,
      //       endTrigger: '.stacked-card-container',
      //       end: (i) => `bottom top+=${(i < cards.length - 1 ? 0 : 120) + card.clientHeight + (cards.length * spacer)}`,
      //       pin: true,
      //       pinSpacing: false,
      //       id: 'pin',
      //       ease: "none.none",
      //       invalidateOnRefresh: true,
      //     });
      //   });
      // },

      // all
      "all": () => {
        cards.forEach((card, index) => {
          const player = card.querySelector('lottie-player');

          if (player) {
            // player.addEventListener('complete', ()=>{
            //   const nextCard = cards[index+1];
            //   if (!nextCard) return;
            //   console.log('finished', index);
            //   nextCard.querySelector('lottie-player').play(0);
            // })

            player.addEventListener('frame', (a)=>{
              const frames = player._lottie.totalFrames;
              if (a.detail.frame > frames - 80) {
                const nextCard = cards[index+1];
                if (!nextCard) return;
                nextCard.querySelector('lottie-player').play(0);
              }
            })
          }

          if (index === 0) {
            gsap.to(card, {
              scrollTrigger: {
                trigger: card,
                start: `top center`,
                end:'top bottom',
                markers: false,
                invalidateOnRefresh: true
              },
              ease: "none",
              onStart: () =>{
                if (player) {
                  player.stop(0);
                  player.play(0);
                }
              }
            });
          }
        });
      }
    })
  }
  stackedCards();
}
